import  ActiveRecord from "@/models/ActiveRecord";

export default class Option extends ActiveRecord {
  // entity is a required property for all models.
  static entity = "option";

  //foreign key of the parent entity
  static foreignKey = "step_id";

  // List of all fields (schema) of the post model. `this.attr()` declares
  // a generic field type with a default value as the first argument.
  static fields() {
    return {

      id: this.uid( () => this.uuidv4() ),
      step_id: this.attr(null),
      title: this.attr('An option title'),
      description: this.attr('An option subtitle'),
      image: this.attr('undraw/undraw_Post_re_mtr4'),
      image_link: this.attr(null),
      goto: this.attr('next'),
      goto_link: this.attr(null),
      order: this.number(null),
      value: this.attr(null),
      selected: this.boolean(false) // This tracks the temporary selected state of the option, but is not saved to database
      
    };
  }

  //Sample Step data
  //fk_val = foreign key value (step_id)
  static dummyData(parent_id){

    return {
      id: this.uuidv4(),
      step_id: parent_id,
      title: "A brand new option",
      description: "A new description",
      image: "undraw/undraw_Post_re_mtr4",
      order: 99999  //dummy value to ensure it is inserted at end of list; real order value will be determined in afterCreate hook
    }

  }

  static clone(orig){

    let option = { ...orig }; //Copy step object
    option.id = this.uuidv4();  //Replace option id

    return option;

  }

  static afterCreate(model){

    this.reorder(model);

  }

  static afterDelete(model){

    this.reorder(model);

  }

}
